<template>
  <nd-dialog
    v-model="visible"
    close-btn
    :footer="false"
    title="平台优惠说明"
  >
    <div class="coupon-content">
      <div class="coupon-info">
        <p>优惠券使用：当前借据借款成功，对应选中的优惠券才会使用。</p>
        <p>如放款失败，有效期内，您勾选的优惠券自动返还。</p>
        <p>优惠金额按最终放款金额和优惠规则生效。</p>
      </div>
    </div>
  </nd-dialog>
</template>

<script>
export default {
  name: 'couponDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
 
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.coupon-content{
  padding: 30px 40px;
  text-align: left;
  .coupon-info{
    font-size: 28px;
    padding-bottom: 20px;
  }
}
</style>